import React from 'react';
import { ArrowRightIcon, CheckIcon, LockIcon } from 'lucide-react';
import { CtaButton } from '../CtaButton';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { useLaunchExpired } from '../../hooks/useLaunchCountdown';
import { PRICING, PRICING_OPTIONS } from '../../data/content';
const BENEFITS = ['6 tomos completos, desde nivel inicial', '5 bonos exclusivos incluidos', 'Modelos para crear, usar y vender', 'Acceso 100% digital e inmediato', 'Garantía de 7 días'];
export function Pricing() {
  const isExpired = useLaunchExpired();
  const product = PRICING_OPTIONS[0];
  if (!product) return null;
  return <section className="w-full px-5 py-14 sm:py-20" aria-labelledby="pricing-title" data-id="element-184" data-mp="3ughslez677n0">
      <div className="mx-auto max-w-xl" data-id="element-185" data-mp="3brk52wwzfqw">
        <Reveal className="text-center" data-id="element-186" data-mp="204ta52tqcmxv">
          <SectionBadge data-id="element-187" data-mp="205uxa5o0szvy">{isExpired ? 'Acceso disponible' : 'Oferta de lanzamiento'}</SectionBadge>
          <h2 id="pricing-title" tabIndex={-1} className="mt-5 font-display text-3xl leading-tight text-cocoa outline-none sm:text-5xl" data-id="element-188" data-mp="254fppix16f9u">
            Tu colección empieza <span className="italic text-terra" data-id="element-189" data-mp="16k9yy4wmo3i3">hoy</span>
          </h2>
        </Reveal>

        <Reveal delay={60} className="mt-10" data-id="element-190" data-mp="11kx3wwvlrq4f">
          <article className="rounded-3xl border-2 border-terra bg-cream-card px-5 py-7 shadow-[0_24px_60px_rgba(58,41,32,0.14)] sm:p-9" data-id="element-191" data-mp="11lqc82a7mnoo">
            <header className="text-center" data-id="element-192" data-mp="xhikrxcdatmr">
              <h3 className="font-display text-[26px] leading-tight text-cocoa sm:text-3xl" data-id="element-193" data-mp="1u9uhwnss70rd">{product.name}</h3>
              <p className="mt-1.5 text-sm font-extrabold uppercase tracking-wide text-terra" data-id="element-194" data-mp="1pbt1ybqnjhk4">{product.description}</p>

              {!isExpired && <p className="mt-5 text-sm font-semibold text-cocoa-dim line-through" data-id="element-195" data-mp="1lb0r5e24t4lq">
                  {PRICING.totalValueOld} {PRICING.currency}
                </p>}
              <p className={`font-display text-[52px] leading-none text-cocoa sm:text-7xl ${isExpired ? 'mt-5' : 'mt-1'}`} data-id="element-196" data-mp="9uit59ivytwz">
                {product.price}{' '}
                <span className="font-sans text-base font-bold text-cocoa-dim" data-id="element-197" data-mp="6c3bkkqy0u63">{PRICING.currency}</span>
              </p>
              {!isExpired && <p className="mt-2 text-sm font-extrabold text-olive" data-id="element-198" data-mp="b9lm2fklzhg7">
                  Ahorrás {PRICING.savings} {PRICING.currency}
                </p>}
              <p className="mt-2 text-sm font-bold text-cocoa" data-id="element-199" data-mp="1cqpi27wbr4k">
                {isExpired ? 'Precio actualizado · un solo pago' : 'Un solo pago, sin suscripciones'}
              </p>
            </header>

            <ul className="mt-7 space-y-3 border-t border-sand-line pt-6" aria-label={`Incluye ${product.name}`} data-id="element-200" data-mp="3oh6jed8anka7">
              {BENEFITS.map(benefit => <li key={benefit} className="flex items-start gap-3 text-sm font-medium leading-snug text-cocoa sm:text-base" data-id="element-201" data-mp="39tv4q2gtfk5v">
                  <CheckIcon className="mt-0.5 h-4 w-4 flex-shrink-0 text-olive" aria-hidden="true" data-id="element-202" data-mp="3epkbapr961bo" />
                  {benefit}
                </li>)}
            </ul>

            <CtaButton className="mt-8 w-full" href={product.checkoutUrl} data-id="element-203" data-mp="35pngs7i6m88p">
              Quiero acceder ahora <ArrowRightIcon className="h-4 w-4 flex-shrink-0" aria-hidden="true" data-id="element-204" data-mp="2m5ybzwywmwc9" />
            </CtaButton>

            <p className="mt-3 flex items-center justify-center gap-2 text-xs font-semibold text-cocoa-dim" data-id="element-205" data-mp="2h7n25m8m0lu1">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-206" data-mp="2v768qalrvp48" />
              Pago seguro · Acceso inmediato por email
            </p>
          </article>
        </Reveal>
      </div>
    </section>;
}